import { C_CURRENCY } from "@/src-refactor/modules/shared/model/const/currency.conts";
import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";

const LOCALE_FILTERS_PROPERTIES = {
  cities_property: [],
  sector_property: [],
  currency_price_property: [C_CURRENCY.RD],
  price_min_property: "",
  price_max_property: "",
  my_properties: false,
  business_type_property: [],
  detail_type_property: [],
  status_property: [],
  percent_commission_property: "",
  meters_land_max_property: "",
  meters_land_min_property: "",
  meters_construction_max_property: "",
  meters_construction_min_property: "",
  maintenance_max_property: "",
  maintenance_min_property: "",
  maintenance_currency_property: [C_CURRENCY.RD],
  condition_property: [],
  type_property: [],
  bedroom_property: [],
  bathroom_property: [],
  parking_property: [],
  level_floor_property: [],
  improvements_property: [],
  agencies_property: [],
  agents_property: [],
  masterBroker_property: false,
  search: "",
  fideicomiso_property: [],
  page: 1,
  delivers: "",
  is_collection_property: false
};

export default LOCALE_FILTERS_PROPERTIES;

export type I_LOCALE_FILTERS_PROPERTIES = {
  cities_property: I_GENERIC_ITEMS[];
  sector_property: I_GENERIC_ITEMS[];
  currency_price_property: I_GENERIC_ITEMS[];
  price_min_property: string;
  price_max_property: string;
  my_properties: boolean;
  business_type_property: I_GENERIC_ITEMS[];
  detail_type_property: I_GENERIC_ITEMS[];
  status_property: I_GENERIC_ITEMS[];
  percent_commission_property: string;
  meters_land_max_property: string;
  meters_land_min_property: string;
  meters_construction_max_property: string;
  meters_construction_min_property: string;
  maintenance_max_property: string;
  maintenance_min_property: string;
  maintenance_currency_property: I_GENERIC_ITEMS[];
  condition_property: I_GENERIC_ITEMS[];
  type_property: I_GENERIC_ITEMS[];
  bedroom_property: number[];
  bathroom_property: number[];
  parking_property: number[];
  level_floor_property: number[];
  improvements_property: I_GENERIC_ITEMS[];
  agencies_property: I_GENERIC_ITEMS[];
  agents_property: I_GENERIC_ITEMS[];
  masterBroker_property: boolean;
  fideicomiso_property: I_GENERIC_ITEMS[];
  search: string;
  page: number;
  delivers: string;
  is_collection_property: boolean;
};

export { LOCALE_FILTERS_PROPERTIES };
